// TODO: we should probably create a class for this service so we can extend it rather than manipulate directly
export default function LayoutFactory() {
  return {
    headerNavAPI: {
      isVisible: true
    },
    subNavApi: {
      hasUnspscs: function () {
        //
      },
      canSendRequest: function () {
        //
      },

      submitPricingRequest: () => {
        //
      }
    }
  };
}
